module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gg-30f47622e942430014e8123ba7e1cfee.svg";